import React, {useEffect} from "react";
import {IAppEntity} from "../../../../config/entities";
import {DataGrid, DropDownBox} from "devextreme-react";
import {ProductService} from "../../../../services/catalogs/ProductService";
import {Column} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";

interface IProps {
    children?: React.ReactNode;
    id?: string;
    text?: string;
    onValueChanged?: (newValue: any) => void;
    entity?: IAppEntity;
}

export const NFLookupEntity = ({id, text, onValueChanged, entity, children}:IProps) => {
    const childrenArray = React.Children.toArray(children);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    
    const dataStore = new CustomStore({
        key: "id",
        load: async (options) => {
            try {
                return {
                    data: [],
                    totalCount: 0,
                }
            } catch (e) {
                console.log("e", e)
            }
        }
    });
    
    // const [entities, setEntities] = React.useState<any[]>([]);
    
    // const fetchEntities = async () => {
    //     const dataService = entity?.getDataService() as ProductService;
    //     const entities = await dataService?.GetAll(undefined);
    //     console.log("entities", entities)
    //     setEntities(entities);
    // };

    useEffect(() => {
        // fetchEntities();
    }, []);
    
    const renderContent = () => {
        return (
            <>
                <DataGrid dataSource={dataStore} searchPanel={{visible: true}}>
                    {childrenArray.map((child: any) => {
                        return (
                            <Column width={100} dataField={child.props.fieldName} />
                        )
                    })}
                </DataGrid>
            </>
        );
    }
    
    return (
        <>
            <DropDownBox id={id} value={text} valueExpr={"id"} displayExpr={"name"} onValueChanged={onValueChanged} contentRender={renderContent}  />
        </>
    );
}